// extracted by css-extract-rspack-plugin
export default {"widgetAddressMap":"widget-address-map--CakdEKGyMPISsszz"};